import {
  ADD_DEEPFAKE_ALLOW_LIST_ASYNC,
  ADD_WARNING_REPORT_RECIPIENTS_ASYNC,
  CREATE_DEEPFAKE_KEY_MEMBER_ASYNC,
  DELETE_DEEPFAKE_ALLOW_LIST_ASYNC,
  DELETE_DEEPFAKE_KEY_MEMBER_ASYNC,
  DELETE_WARNING_REPORT_RECIPIENTS_ASYNC,
  GET_DEEPFAKE_ALLOW_LIST_ASYNC,
  GET_DEEPFAKE_CONFIG_ASYNC,
  GET_DEEPFAKE_KEY_MEMBERS_ASYNC,
  GET_DEEPFAKE_MAILBOX_LIST_ASYNC,
  GET_WARNING_REPORT_CANDIDATES_ASYNC,
  GET_WARNING_REPORT_RECIPIENTS_ASYNC,
  SET_DEEPFAKE_MAILBOX_LIST_PAGE,
  SET_DEEPFAKE_MAILBOX_LIST_VALUE,
  SET_DEEPFAKE_WARNING_REPORT_RECIPIENT,
  SET_EMPLOYEE_INFO,
  SET_EMPLOYEE_INFO_FIELD,
  UPDATE_DEEPFAKE_CONFIG_ASYNC,
  UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    switchersLoader: false,
    employeeInfo: {},
    mailboxData: {
      data: [],
      value: null,
      loader: false,
      error: null,
      page: 0,
    },
    keyMembersData: {
      loader: false,
      error: null,
      items: [],
      total: 0,
    },
    keyMemberLoader: false,
    keyMemberError: null,
    warningReportRecipients: {
      items: [],
      loader: false,
      error: null,
    },
    allowListData: {
      items: [],
      loader: false,
      error: null,
    },
    addAllowListLoader: false,
    candidatesLoader: false,
    candidates: [],
    selectedRecipientId: null,
    warningReportRecipientsLoader: false,
    deleteAllowListLoader: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GET_DEEPFAKE_CONFIG_ASYNC.INITIATE:
        return { ...state, switchersLoader: true }
      case GET_DEEPFAKE_CONFIG_ASYNC.SUCCESS:
        return {
          ...state,
          switchersLoader: false,
          showPopup: action.payload.data.showPopup,
          sendWarningReportNotification: action.payload.data.sendWarningReportNotification,
        }
      case GET_DEEPFAKE_CONFIG_ASYNC.ERROR:
        return {
          ...state,
          switchersLoader: false,
        }
      case GET_DEEPFAKE_CONFIG_ASYNC.CANCEL:
        return { ...state, switchersLoader: false }
      case UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE:
        return {
          ...state,
          showPopup: state.showPopup,
          sendWarningReportNotification: state.sendWarningReportNotification,
          [action.payload.key]: !state[action.payload.key],
        }
      case GET_DEEPFAKE_MAILBOX_LIST_ASYNC.INITIATE:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            loader: true,
            error: null,
          },
        }
      case GET_DEEPFAKE_MAILBOX_LIST_ASYNC.SUCCESS:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            data:
              state.mailboxData.page === 1
                ? action.payload.data.items
                : [...state.mailboxData.data, ...action.payload.data.items],
            loader: false,
            count: action.payload.data.count,
          },
        }
      case GET_DEEPFAKE_MAILBOX_LIST_ASYNC.ERROR:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            error: action.error,
            loader: false,
          },
        }
      case GET_DEEPFAKE_MAILBOX_LIST_ASYNC.CANCEL:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            loader: false,
          },
        }
      case SET_DEEPFAKE_MAILBOX_LIST_VALUE:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            value: action.payload.value,
          },
        }
      case SET_DEEPFAKE_MAILBOX_LIST_PAGE:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            page: action.payload.page,
          },
        }
      case SET_EMPLOYEE_INFO: {
        return {
          ...state,
          employeeInfo: action.payload.data,
        }
      }
      case SET_EMPLOYEE_INFO_FIELD: {
        return {
          ...state,
          employeeInfo: {
            ...state.employeeInfo,
            [action.payload.field]: action.payload.value,
          },
        }
      }
      case GET_DEEPFAKE_KEY_MEMBERS_ASYNC.INITIATE:
        return {
          ...state,
          keyMembersData: {
            ...state.keyMembersData,
            loader: true,
            error: null,
          },
        }
      case GET_DEEPFAKE_KEY_MEMBERS_ASYNC.SUCCESS:
        return {
          ...state,
          keyMembersData: {
            loader: false,
            error: null,
            ...action.payload.data,
          },
        }
      case GET_DEEPFAKE_KEY_MEMBERS_ASYNC.ERROR:
        return {
          ...state,
          keyMembersData: {
            ...state.keyMembersData,
            loader: false,
            error: action.error,
          },
        }
      case CREATE_DEEPFAKE_KEY_MEMBER_ASYNC.INITIATE:
      case UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC.INITIATE:
      case DELETE_DEEPFAKE_KEY_MEMBER_ASYNC.INITIATE:
        return {
          ...state,
          keyMemberLoader: true,
          keyMemberError: null,
        }
      case CREATE_DEEPFAKE_KEY_MEMBER_ASYNC.SUCCESS:
      case DELETE_DEEPFAKE_KEY_MEMBER_ASYNC.SUCCESS:
      case UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC.SUCCESS:
        return {
          ...state,
          keyMemberLoader: false,
        }
      case CREATE_DEEPFAKE_KEY_MEMBER_ASYNC.ERROR:
      case DELETE_DEEPFAKE_KEY_MEMBER_ASYNC.ERROR:
      case UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC.ERROR:
        return {
          ...state,
          keyMemberLoader: false,
          keyMemberError: action.error,
        }
      case GET_WARNING_REPORT_RECIPIENTS_ASYNC.INITIATE:
        return {
          ...state,
          warningReportRecipients: {
            ...state.warningReportRecipients,
            loader: true,
            error: null,
          },
        }
      case GET_WARNING_REPORT_RECIPIENTS_ASYNC.SUCCESS:
        return {
          ...state,
          warningReportRecipients: {
            ...state.warningReportRecipients,
            loader: false,
            ...action.payload.data,
          },
        }
      case GET_WARNING_REPORT_RECIPIENTS_ASYNC.ERROR:
        return {
          ...state,
          warningReportRecipients: {
            ...state.warningReportRecipients,
            loader: false,
            error: action.error,
          },
        }
      case GET_WARNING_REPORT_CANDIDATES_ASYNC.INITIATE:
        return {
          ...state,
          candidatesLoader: true,
        }
      case GET_WARNING_REPORT_CANDIDATES_ASYNC.SUCCESS:
        return {
          ...state,
          candidatesLoader: false,
          candidates: action.payload.data.items,
        }
      case GET_WARNING_REPORT_CANDIDATES_ASYNC.ERROR:
        return {
          ...state,
          candidatesLoader: false,
        }
      case SET_DEEPFAKE_WARNING_REPORT_RECIPIENT:
        return {
          ...state,
          selectedRecipientId: action.payload.id,
        }
      case ADD_WARNING_REPORT_RECIPIENTS_ASYNC.INITIATE:
      case DELETE_WARNING_REPORT_RECIPIENTS_ASYNC.INITIATE:
        return {
          ...state,
          warningReportRecipientsLoader: true,
        }
      case ADD_WARNING_REPORT_RECIPIENTS_ASYNC.SUCCESS:
      case ADD_WARNING_REPORT_RECIPIENTS_ASYNC.ERROR:
      case DELETE_WARNING_REPORT_RECIPIENTS_ASYNC.SUCCESS:
      case DELETE_WARNING_REPORT_RECIPIENTS_ASYNC.ERROR:
        return {
          ...state,
          warningReportRecipientsLoader: false,
        }
      case GET_DEEPFAKE_ALLOW_LIST_ASYNC.INITIATE:
        return {
          ...state,
          allowListData: {
            ...state.allowListData,
            loader: true,
            error: null,
          },
        }
      case GET_DEEPFAKE_ALLOW_LIST_ASYNC.SUCCESS:
        return {
          ...state,
          allowListData: {
            ...state.allowListData,
            items: action.payload.data.items,
            loader: false,
            error: null,
          },
        }
      case GET_DEEPFAKE_ALLOW_LIST_ASYNC.ERROR:
        return {
          ...state,
          allowListData: {
            ...state.allowListData,
            loader: false,
            error: action.error,
          },
        }
      case ADD_DEEPFAKE_ALLOW_LIST_ASYNC.INITIATE:
        return {
          ...state,
          addAllowListLoader: true,
        }
      case ADD_DEEPFAKE_ALLOW_LIST_ASYNC.SUCCESS:
      case ADD_DEEPFAKE_ALLOW_LIST_ASYNC.ERROR:
        return {
          ...state,
          addAllowListLoader: false,
          addAllowListError: action.error?.response?.detail?.[0],
        }
      case DELETE_DEEPFAKE_ALLOW_LIST_ASYNC.INITIATE:
        return {
          ...state,
          deleteAllowListLoader: true,
        }
      case DELETE_DEEPFAKE_ALLOW_LIST_ASYNC.SUCCESS:
      case DELETE_DEEPFAKE_ALLOW_LIST_ASYNC.ERROR:
        return {
          ...state,
          deleteAllowListLoader: false,
        }

      default:
        return state
    }
  }
}
